import React from 'react';
import * as styles from './analytics.module.styl';

export default function AnalyticsAnimation() {
  return (
    <svg
      width="444px"
      height="444px"
      className="max-w-full h-auto"
      viewBox="0 0 444 444"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="analytics"
        transform="translate(-247.437710, 0.000000)"
        fillRule="nonzero"
      >
        <rect
          id="Rectangle"
          fill="#F2F0E8"
          x="247.43771"
          y="0"
          width="446"
          height="424"
        />
        <path
          className={styles.path1}
          d="M28.3966908,303.123368 C18.6727227,196.620466 19.7306735,137.725237 31.5705435,126.437682 C67.2193229,92.4518722 153.792328,186.603294 195.851308,170.200268 C272.104243,140.461581 333.537134,169.310551 369.578335,199.5 C427.96896,248.410156 491.101772,262.070313 532.039273,207.0625 C572.976773,152.054687 621.979272,131.916012 674.40646,163.160156 C690.549771,172.780812 713.558121,123.935928 735.162084,126.437682 C749.850414,128.138601 758.915841,193.553088 800.893703,187.835984 C859.873165,179.803376 902.563809,179.803376 938.5791,170.200268 L781.554897,444.296875 L175.414272,444.296875"
          id="Path-Copy"
          fill="#DD785B"
        />
        <path
          className={styles.path2}
          d="M350.777554,244.5 C438.952274,318.358421 560.246272,96.1323165 674.40646,208.160156 C750.513252,282.845383 877.224955,276.427415 938.5791,244.648438 L880.597866,489.296875 L0,489.296875 L34.9744299,332.631279 C63.710264,273.976051 98.1475259,232.485677 138.286215,208.160156 C207.57008,166.171588 323.805558,221.907255 350.777554,244.5 Z"
          id="Path"
          fill="#FFC84E"
        />
      </g>
    </svg>
  );
}
